import React, { Fragment, useEffect, useState } from 'react';
import ComplaintCategory from '../../models/ComplaintCategory';
import { getApi } from '../../api/endpoints';
import Multiselect from 'multiselect-react-dropdown';
import ToggleSwitch from '../../components/ToggleSwitch';

const FormPartial = (props) => {
  const { complaintCategory, setComplaintCategory } = props;
  let complaintCategoryObj = new ComplaintCategory(complaintCategory);
  const [categoriesApi] = getApi('categories');
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchCategories();
  }, [])

  const fetchCategories = async () => {
    try {
      const response = await categoriesApi({ fields: 'options' }).unwrap();
      setCategories(response.data.categories);
    } catch (error) {
    }
  }

  const onCategorySelect = (key, selectedItem, array_key = false) => {
    if(array_key){
      complaintCategoryObj[key].push(selectedItem.id);
    } else {
      complaintCategoryObj[key] = selectedItem.id;
    }
    validateValue(key);
    setComplaintCategory(complaintCategoryObj.toStateJson());

  }

  const validateValue = (field) => {
    complaintCategoryObj.validate(field);
  }

  const changeValue = (field, value) => {
    complaintCategoryObj[field] = value;
    validateValue(field);
    props.setComplaintCategory(complaintCategoryObj.toStateJson());
  }

  const selectedCategory = () => {
    return categories.filter((category) => category?.id == complaintCategory.parent_category_id)
  }

  return <Fragment>
    <div className="mb-1 col-md-6">
      <label htmlFor="name" className="form-label mb-1">Name</label>
      <input 
        id="name"
        value={complaintCategory.name}
        onChange={(e) => changeValue('name', e.target.value)}
        type="text"
        className="form-control form-control-sm font-size-10"
        aria-describedby="name_help"
        placeholder='Enter Complaint Category Name'
      />
      <div id="name_help"className="form-text text-danger mt-0">
        {complaintCategory.errors.name}
      </div>
    </div>
    <div className="mb-1 col-md-6">
      <label htmlFor='parent_category_id' className="form-label mb-1">Select Parent Category</label>
      <Multiselect
        id='parent_category_id'
        selectedValues={selectedCategory()}
        options={categories}
        displayValue={'name'}
        avoidHighlightFirstOption={true}
        onSelect={(selectedList, selectedItem) => onCategorySelect('parent_category_id', selectedItem)}
        customArrow={true}
        placeholder='Select Parent Category'
        singleSelect={true}
      />
    </div>
    <div className="mb-1 col-md-6">
      <label htmlFor="inactive" className="form-label mb-1">Status</label>
      <ToggleSwitch
        id="inactive"
        label_left="Inactive"
        label_right ="Active"
        onChange={(e) => changeValue('inactive', !complaintCategoryObj.inactive)}
        checked={complaintCategoryObj.inactive}
      />
    </div>
    <div className="mb-1 col-md-6">
      <label htmlFor="description" className="form-label mb-1">Description</label>
      <textarea
        id="description"
        value={complaintCategory.description}
        onChange={(e) => changeValue('description', e.target.value)}
        type="textarea"
        className="form-control form-control-sm font-size-10"
        aria-describedby="description_help"
        placeholder='Enter Complaint Category Description'
      />
    </div>
  </Fragment>
}

export default FormPartial;
